export default __webpack_public_path__ + "static/media/profile2.5dd83b33.jpeg";